export var BrandingImage;
(function (BrandingImage) {
    BrandingImage["FAVICON"] = "favicon";
    BrandingImage["LOGO"] = "logo";
})(BrandingImage || (BrandingImage = {}));
